<template>
  <div class="active-box" @click="handle2Active">
    <div class="title">
      <span
        :class="
          active.type === 1
            ? 'span2'
            : active.type === 2
            ? 'span1'
            : active.type === 3
            ? 'span3'
            : active.type === 4
            ? 'span4'
            : active.type === 5
            ? 'span4'
            : 'span5'
        "
        >{{ active.type | type }}</span
      >
      <span class="van-ellipsis">{{ active.title }}</span>
      <span>{{ startOrEndText(active) }}</span>
    </div>
    <div class="date">
      <span>{{ active.time }}</span>
      <span>
        <img src="@/assets/image/home/more.png" alt="" />
      </span>
    </div>
    <div class="author">{{ active.user_name }} | 主讲</div>
  </div>
</template>

<script>
export default {
  props: ['active'],
  filters: {
    type(type) {
      switch (type) {
        case '1':
          return '录播预约'
        case '2':
          return '同步课堂'
        case '3':
          return '视频会议'
        case '4':
          return '直播教研'
        case '5':
          return '互动教研'
        case '6':
          return '直播教学'
        case '7':
          return '直播'
        default:
          return '自定义活动'
      }
    }
  },
  methods: {
    startOrEndText(item) {
      const date = +new Date()
      if (date < item.event_start_time) {
        return '课程未开始'
      } else if (date >= item.event_start_time && date < item.event_end_time) {
        return '课程进行中'
      } else if (date >= item.event_end_time) {
        return '课程已结束'
      }
    },
    handle2Active() {
      this.$router.push(`/play/${this.active.id}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.active-box {
  padding: 20px 16px;
  background: #ffffff;
  box-shadow: 0px 0px 12px 0px rgba(23, 38, 71, 0.04);
  border-radius: 12px;
  margin-bottom: 20px;
}
.title {
  display: flex;
  align-items: center;
  span {
    &:nth-child(1) {
      padding: 2px 4px;
      border-radius: 3px;
      font-size: 10px;
    }
    &:nth-child(2) {
      color: #303133;
      font-size: 14px;
      font-weight: 700;
      margin-left: 10px;
      padding-right: 10px;
      flex: 1;
    }
    &:nth-child(3) {
      color: #999;
      font-size: 10px;
    }
  }
}
.author {
  color: #909399;
  font-size: 12px;
}
.date {
  display: flex;
  align-items: center;
  justify-content: space-between;
  line-height: 2;
  span {
    &:nth-child(1) {
      color: #303133;
      font-size: 20px;
    }
    img {
      vertical-align: middle;
      width: 24px;
    }
  }
}
.span1 {
  background: rgba(68, 101, 243, 0.2);
  color: #4465f3;
}

.span2 {
  background: rgba(253, 164, 35, 0.2);
  color: rgba(253, 164, 35, 1);
}

.span3 {
  background: rgba(161, 168, 184, 0.2);
  color: rgba(161, 168, 184, 1);
}

.span4 {
  background: rgba(119, 98, 212, 0.2);
  color: rgba(119, 98, 212, 1);
}

.span5 {
  background: rgba(244, 106, 106, 0.2);
  color: rgba(244, 106, 106, 1);
}
</style>
